import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { useUnifiedAgentContext } from 'pages/chatbot/ui/UnifiedAgent/context/unifiedAgentContext'
import { KnowledgeBase } from '../KnowledgeBaseSection/KnowledgeBase'
import { AutoFollowUpSection } from '../AutoFollowUpSection/AutoFollowUpSection'
import { TriggerSection } from '../TriggerSection/TriggerSection'
import styles from './styles.module.scss'
import { InstructionsSection } from '../InstructionsSection/InstructionsSection'
import { BookingSection } from '../BookingSection/BookingSection'
import { SectionButtons } from './ui/SectionButtons'

export const Configure = observer(() => {
  const {
    isLoadingSection,
    updateInstructions,
    resetEditSection,
    knowledgeBaseSectionStore,
    bookingSectionStore,
  } = useUnifiedAgentContext()

  return (
    <>
      <div className={styles.section}>
        <TriggerSection />
      </div>
      <div className={styles.section}>
        <InstructionsSection />
      </div>
      <div className={classnames(styles.section, styles.editableSection)}>
        <KnowledgeBase />
        {knowledgeBaseSectionStore.hasChanges && (
          <SectionButtons
            isLoading={isLoadingSection}
            isDisabled={knowledgeBaseSectionStore.isLoading}
            onCancel={() => resetEditSection('knowledgeBase')}
            onSave={() => updateInstructions('knowledgeBase')}
          />
        )}
      </div>
      <div className={classnames(styles.section, styles.editableSection)}>
        <BookingSection />
        {bookingSectionStore.hasChanges && (
          <SectionButtons
            onCancel={() => resetEditSection('booking')}
            onSave={() => updateInstructions('booking')}
            isLoading={isLoadingSection}
          />
        )}
      </div>
      <div className={styles.section}>
        <AutoFollowUpSection />
      </div>
    </>
  )
})
